import { ThemeComponents } from '@chakra-ui/react';

const components: ThemeComponents = {
  Input: {
    baseStyle: {
      field: {
        bg: 'bg_main_input',
        _disabled: {
          _dark: {
            opacity: 0.4,
          },
          _light: {
            bg: 'grey.300',
          },
          cursor: 'not-allowed',
        },
        _focus: {
          border: 'border_main',
        },
        border: 'border_gray_solid',
      },
    },
    defaultProps: {
      variant: 'dark_mode',
    },
  },
  Textarea: {
    baseStyle: {
      bg: 'bg_main_input',
      _disabled: {
        _dark: {
          opacity: 0.4,
        },
        _light: {
          bg: 'grey.300',
        },
        cursor: 'not-allowed',
      },
      _focus: {
        border: 'border_main',
      },
    },
    defaultProps: {
      variant: 'dark_mode',
    },
  },
  Button: {
    variants: {
      submit: {
        bg: 'main_color',
        _disabled: {
          opacity: 0.8,
        },
        _hover: {
          opacity: 0.8,
        },
      },
      submit_summary: {
        bg: 'main_summary_color',
        _disabled: {
          opacity: 0.8,
        },
        _hover: {
          opacity: 0.8,
        },
      },
      link: {
        _dark: {
          bg: 'none',
        },
        _light: {
          bg: 'none',
        },
      },
      ghost: {
        _light: {
          _hover: {
            bg: 'gray.300',
          },
        },
      },
      action: {
        _light: {
          _hover: {
            bg: 'gray.400',
          },
          bg: 'gray.300',
        },
        _dark: {
          _hover: {
            bg: 'grey.500',
          },
          bg: 'grey.400',
        },
      },
      amatrium_submit: {
        _dark: {
          bg: 'main_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      amatrium_view_btn: {
        _dark: {
          bg: 'main_summary_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      amatrium_back_btn: {
        _dark: {
          bg: 'sub_main_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      cancel: {
        _dark: {
          bg: 'grey.700',
          color: 'color_main_text',
          _hover: {
            bg: 'grey.600',
          },
        },
        _light: {
          bg: 'grey.100',
          color: 'color_main_text',
          _hover: {
            bg: 'grey.200',
          },
        },
      },
    },
    baseStyle: {
      fontWeight: 'normal',
      _focus: {
        border: 0,
        boxShadow: 0,
      },
      _active: {
        border: 0,
        boxShadow: 0,
      },
    },
    defaultProps: {
      variant: 'solid',
    },
  },
  IconButton: {
    baseStyle: {
      _focus: {
        border: 0,
        boxShadow: 0,
      },
    },
  },
  Link: {
    variants: {
      selected: {
        _dark: {
          color: 'grey.50',
          bg: 'transparent',
        },
        _light: {
          color: 'black',
          bg: 'amatrium_border',
        },
      },
      button: {
        _dark: {
          _activeLink: {
            color: 'grey.50',
            bg: 'main_color',
          },
        },
        _light: {
          _activeLink: {
            color: 'grey.50',
            bg: 'primary.500',
          },
        },
      },
      dropdown: {
        _dark: {
          color: 'grey.300',
          bg: 'transparent',
          _hover: {
            bg: 'grey.700',
            color: 'grey.50',
          },
        },
        // _light: {
        //   color: "black",
        //   bg: "amatrium_border",
        // },
      },
    },
    baseStyle: {
      _focus: {
        border: '0px',
        boxShadow: '0px',
      },
      _hover: {
        textDecoration: 'none',
      },
      _dark: {
        color: 'grey.500',
        _hover: {
          bg: 'grey.600',
          color: 'grey.50',
        },
      },
      _light: {
        color: 'amatrium.800',
        _hover: {
          bg: 'amatrium_border',
          color: 'black',
        },
      },
      fontWeight: '600',
    },
    defaultProps: {
      variant: 'default',
    },
  },
  Tag: {
    baseStyle: {
      background: '#E8DAF3',
      borderRadius: '0.75rem',
      px: '0.75rem',
    },
  },
  Heading: {
    baseStyle: {
      fontFamily: 'montserrat',
      fontWeight: 500,
      color: 'color_main_text',
    },
  },
  FormLabel: {
    baseStyle: {
      color: 'color_main_text',
    },
  },
  Table: {
    baseStyle: {
      color: 'color_main_text',
    },
  },
  Tooltip: {
    baseStyle: (props: any) => ({
      bg: props.colorMode === 'dark' ? '#363f50' : 'white',
      color: props.colorMode === 'dark' ? 'white' : 'black',
    }),
  },
};

export default components;
